import { render, staticRenderFns } from "./OwnClassListAction.vue?vue&type=template&id=ea51fc36"
import script from "./OwnClassListAction.vue?vue&type=script&lang=js"
export * from "./OwnClassListAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports